import React, { useState, useEffect, useRef } from "react";
import axiosInstance from '../axiosInstance';
import { FaSearch, FaPlus, FaFilter } from "react-icons/fa";
import { API_URL_All } from "../api";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

import * as general from '../libs/general';
import Paging from '../components/Paging';
import AdLayout from '../components/AdLayout';
import DataTable from '../components/ui/DataTable';
import { StarRating, LockingTicket } from '../components/tickets/Tickets';
import { fetchProviderMenuPermissions } from "../libs/customerCreatePermission";

const Providers = () => {
  const [providerEditorData, setproviderEditorData] = useState(null);
  const [pageData, setPageData] = useState({ content: [] });
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const hasRun = useRef(false);
  const [stopped, setStopped] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [providerFeaturePerm, setProviderFeaturePerm] = useState({
    loaded: false,
    canView: false,
    canCreate: false,
    canEdit: false,
  });
  const [providerAccess, setProviderAccess] = useState("allowed");


  useEffect(() => {
    console.log(stopped);
    searchProviders();
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const p = await fetchProviderMenuPermissions(axiosInstance);
      if (cancelled) return;
      setProviderFeaturePerm({
        loaded: true,
        canView: Boolean(p.canView),
        canCreate: Boolean(p.canCreate),
        canEdit: Boolean(p.canEdit),
      });
      if (!(p.canView || p.canEdit)) {
        setProviderAccess("denied");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleProviderActiveChange = (value) => {
    var active = true;
    if (value === 0) {
      setStopped(true);
      active = false;
    }
    if (value === 1) {
      setStopped(false);
    }
    searchProviders({ page: 0, active: active });
  };

  const handleChangeItemsPerPage = (e) => {
    const newItemsPerPage = parseInt(e.target.value, 10);
    searchProviders({ page: 0, size: newItemsPerPage });
  };

  const handlePageChange = (page) => {
    searchProviders({ page: page - 1 });
  };
  const handleSearchChange = (e) => {
    var searchValue = e.target.value;
    searchProviders({ page: 0, keyword: searchValue });
    setSearchQuery(e.target.value);
  };

  const searchProviders = async (filter) => {
    if (window.calling) return;
    window.calling = true;
    setIsLoading(true);
    setMessage('');

    var params = general.getSession('search_providers');

    var formData = general.getFormData('.form_filter');
    Object.assign(params, formData);

    if (!hasRun.current) {
      hasRun.current = true;
      var oldParams = general.getSession('search_providers');
      Object.assign(params, oldParams);
    }

    params.active = !stopped;
    if (filter) Object.assign(params, filter);
    general.setSession('search_providers', params);

    window.initializeFilterValue(params);

    var filteredParams = Object.fromEntries(Object.entries(params).filter(([key, v]) => v !== undefined && v !== '' && key + v !== 'page0' && key + v !== 'size550' && key + v !== 'isDeletedfalse'));

    var response = {};
    try {
      response = await axiosInstance.get(`/api/providers/searchProviders`, { params: filteredParams });
      setPageData(response.data);
    } catch (error) {
      setPageData({ content: [] });
      setMessage(error.message);
      console.error(error);
    }
    setIsLoading(false);
    window.calling = false;
  };

  if (providerAccess === "denied") {
    return (
      <div>
        <AdLayout>
          <div className="container py-4">
            <div className="alert alert-warning mb-0">Truy cập không được phép.</div>
          </div>
        </AdLayout>
      </div>
    );
  }


  return (
    <div>
      <AdLayout>
        <div className="table-responsive web-table customer-management-page">
          <div className="container-fluid">
            <div className="row bg-dark align-items-center">
              <div className="col-12 col-md-7 order-3 order-md-1 py-1 d-flex align-items-center">
                <div className="d-flex align-items-center gap-2">
                  <div className="dropdown">
                    <button className="btn btn-info btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <FaFilter />
                    </button>
                    <ul className="dropdown-menu">
                      <li className={`${stopped !== true ? 'fa-checked' : ''}`} onClick={() => handleProviderActiveChange(1)}><span className="dropdown-item">Đang hoạt động</span></li>
                      <li className={`${stopped === true ? 'fa-checked' : ''}`} onClick={() => handleProviderActiveChange(0)}><span className="dropdown-item">Đã ngừng</span></li>
                    </ul>
                  </div>
                  {providerFeaturePerm.canCreate && (
                    <button type="button" className="btn btn-success btn-sm" onClick={() => navigate(`/provider`)} title="Nhà cung cấp mới">
                      <FaPlus /> Thêm mới
                    </button>
                  )}
                </div>
              </div>
              <div className="col-7 col-md-2 py-1 fw-bold text-white text-uppercase d-flex align-items-center justify-content-star order-1 order-md-2">
                {stopped && (<span>NCC đã ngừng hoạt động</span>)}
                {!stopped && (<span>Danh sách nhà cung cấp</span>)}
              </div>
              <div className="col-5 col-md-3 py-1 order-2 order-md-3 d-flex justify-content-end align-items-center">
                <form id="form_filter" className="form_filter mb-0 w-auto">
                  <div className="input-group search-block flex-nowrap">
                    <input name="keyword"
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Tìm kiếm..."
                      value={searchQuery}
                      onChange={(e) => handleSearchChange(e)}  // Ensure `e` is passed to the function
                    />
                    <button className="btn btn-light btn-sm" type="button" title="Tìm kiếm..." onClick={(event) => searchProviders({ page: 0 })}>
                      <FaSearch />
                    </button>
                  </div>
                </form>
              </div>
            </div>


          </div>

          <section className="pt-1">
            <DataTable maxHeight="calc(100vh - 160px)" className="table-normal" data-loading={isLoading}>
              <table className="table table-striped table-bordered border-normal">
                <thead className="table-primary">
                  <tr>
                    <th width="30px" className="sticky">STT</th>
                    <th><span>Tên NCC</span></th>
                    <th width="150px"><span>Mã</span></th>
                    <th><span>Điện thoại</span></th>
                    <th><span>Địa chỉ</span></th>
                    <th>
                      <span>Danh mục</span>
                      <span className="filter-ib" data-form="form_filter" data-filter="categories" data-source-url={API_URL_All + '/api/products/searchTreeCategoryNames'} data-min="190px"><i className="filter-i"></i></span>
                    </th>
                    <th><span>Tổng đơn</span></th>
                    <th><span>Tổng tiền</span></th>
                    <th><span>Xếp hạng</span></th>
                    <th><span>Người phụ trách</span></th>
                  </tr>
                </thead>
                <tbody>
                {pageData.page && pageData.page.content && pageData.page.content.map((item, index) => (
                    <tr key={item.id}>
                    <td className="sticky">{(pageData.page.number * pageData.page.size) + index + 1}</td>
                    <td className="text-start" title={`ID: ${item.id}` }>
                      {providerFeaturePerm.canView || providerFeaturePerm.canEdit ? (
                        <span
                          role="button"
                          tabIndex={0}
                          style={{ color: "#485766" }}
                          onClick={() => navigate(`/provider/${item.id}`)}
                          onKeyDown={(e) => e.key === "Enter" && navigate(`/provider/${item.id}`)}
                          title="Xem chi tiết nhà cung cấp"
                        >
                          {item.name}
                        </span>
                      ) : item.name}
                    </td>
                    <td className="text-start">
                      {providerFeaturePerm.canView || providerFeaturePerm.canEdit ? (
                        <span
                          role="button"
                          tabIndex={0}
                          style={{ color: "#485766" }}
                          onClick={() => navigate(`/provider/${item.id}`)}
                          onKeyDown={(e) => e.key === "Enter" && navigate(`/provider/${item.id}`)}
                          title="Xem chi tiết nhà cung cấp"
                        >
                          {item.code}
                        </span>
                      ) : item.code}
                    </td>
                    <td className="text-start">{item.phone}</td>
                    <td className="text-start">{item.address}</td>
                    <td className="text-start mw-200">
                      {item.categories.map((item2, index2) => (
                        <div className="block-02" key={index2}>{item2.name}</div>
                      ))}
                    </td>
                    <td className="text-center">{general.formatNumber(item.orderCount)}</td>
                    <td className="text-end">{general.formatNumber(item.orderMoney)}</td>
                    <td className="text-start">
                      <div className="flex-between"><span className="min-45">S.phẩm:</span> <StarRating rating={item.starProduct ?? 0} /></div>
                      <div className="flex-between"><span className="min-45">Giá:</span> <StarRating rating={item.starPrice ?? 0} /></div>
                      <div className="flex-between"><span className="min-45">Tốc độ:</span> <StarRating rating={item.starProcess ?? 0} /></div>
                    </td>
                    <td className="text-start">{item.careName || "—"}</td>
                    </tr>
                ))}
                </tbody>
                  <tbody>
                  {message === '' && pageData.page && pageData.page.content.length === 0 && (
                    <tr>
                      <td colSpan="10" className="text-center">Không tìm thấy dữ liệu</td>
                    </tr>
                  )}
                  {message !== '' && (
                    <tr>
                      <td colSpan="10" className="text-center">{message}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </DataTable>
          </section>
          <div className="mt-2 d-flex justify-content-end align-items-center">
            <Paging
              pageData={pageData}
              onPageChange={handlePageChange}
              onItemsPerPageChange={handleChangeItemsPerPage}
            />
          </div>
        </div>

      </AdLayout>
    </div>
  );
}
export default Providers;